import { queryOptions } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import type { SavedFilter } from '@/entities/saved-filter';
import { http } from '@/services/http';

import { normalizeSavedFiltersResponse } from './normalizeSavedFilters';
import { getSavedFiltersApiUrl } from './savedFiltersUrl';

import type { SavedFilterResponse } from './savedFilters.types';

const isNotFoundError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 404;

export const savedFiltersOptions = {
  all: () => ['saved-filters'] as const,

  mutations: {
    all: () => [...savedFiltersOptions.all(), 'mutation'] as const,
    save: () => [...savedFiltersOptions.mutations.all(), 'save'] as const,
    delete: () => [...savedFiltersOptions.mutations.all(), 'delete'] as const
  },

  list: () =>
    queryOptions({
      queryKey: savedFiltersOptions.all(),
      queryFn: async (): Promise<SavedFilter[]> => {
        try {
          const { data } =
            await http.internal.get<Record<string, SavedFilterResponse>>(getSavedFiltersApiUrl());
          return normalizeSavedFiltersResponse(data);
        } catch (error) {
          if (isNotFoundError(error)) return [];
          throw error;
        }
      },
      retry: (failureCount, error) => {
        if (isNotFoundError(error)) return false;
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      staleTime: Infinity,
      structuralSharing: false
    })
};
